
<template>
  <div class="icon-management" :style="'height:' + conHeight + 'px;'" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="menu-contain">
      <div class="menu">
        <div class="top">
          <div class="left-header">
            <span class="left-title">题目标签管理</span>
            <i class="el-icon-circle-plus-outline left-add-icon" @click="add"></i>
          </div>
          <el-input v-model="page.labelName" @change="getList(true)" placeholder="输入关键字搜索" class="search-input">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-tree
            ref="labelTree"
            :data="tableData"
            :props="treeProps"
            node-key="guid"
            :highlight-current="true"
            :current-node-key="currentLabelGuid"
            :default-expanded-keys="expandedKeys"
            class="label-tree"
            @node-click="handleLeft"
          >
            <template slot-scope="{ node, data }">
              <div class="tree-node-content">
                <span class="node-name">{{ node.label }}</span>
                <span class="tree-operate" @click.stop>
                  <el-dropdown trigger="click" @command="(command) => handleTreeCommand(command, data)">
                    <span class="el-icon-more"></span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="edit">编辑</el-dropdown-item>
                      <el-dropdown-item command="del">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
              </div>
            </template>
          </el-tree>
          <div class="import-export-btn">
            <div class="btn-item" @click="importLabel">
              <i class="el-icon-download"></i>
              <span>导入</span>
            </div>
            <div class="btn-divider"></div>
            <div class="btn-item" @click="exportLabel">
              <i class="el-icon-upload2"></i>
              <span>导出</span>
            </div>
          </div>
        </div>
      </div>
      <div class="contain">
        <div class="search-area">
          <div class="label">{{ pageII.labelName }}({{ pageII.totalRows }}个题目)</div>
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="search-area-div" style="width: 102px; font-size: 14px">题目标题：</div>
              <el-input
                class="fl"
                style="width: calc(100% - 102px)"
                v-model="pageII.subjectTitle"
                @change="getList"
                placeholder="输入关键字搜索"
              />
            </el-col>
            <el-col :span="8">
              <div class="search-area-div" style="width: 102px; font-size: 14px">题目类型：</div>
              <el-select class="fl" style="width: calc(100% - 102px)" v-model="pageII.subjectType" filterable placeholder="请选择">
                <el-option
                  v-for="(item, index) in subjectTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6" class="t-right">
              <el-button
                size="mini"
                type="text"
                @click="showMore = !showMore"
                :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              >
                {{ showMore ? '收起筛选' : '更多筛选' }}
              </el-button>
              <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
              <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="24" class="mt15" v-show="showMore">
            <el-col :span="8">
              <div class="search-area-div" style="width: 102px; font-size: 14px">题型分类：</div>
              <el-select 
                class="fl" 
                style="width: calc(100% - 102px)" 
                v-model="pageII.subjectItemType" 
                filterable 
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in getCodeListByKey('题型分类')"
                  :key="index"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>

        <div class="content-main-box back-color-fff">
          <div class="button-area">
            <el-button size="mini" type="info"  @click="addSubject">添加题目</el-button>
            <el-button size="mini" type="default" @click="allDel">批量删除</el-button>
          </div>
          <el-table
            :data="productInformationList"
            style="width: 100%"
            row-key="guid"
            border
            @selection-change="handleSelectionChange"
            ref="dataTable"
          >
            <el-table-column type="selection" :reserve-selection="reserrveSelection"> </el-table-column>
            <el-table-column label="序号" width="70">
              <template slot-scope="scope">
                {{ (pageII.pageIndex - 1) * pageII.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="subjectTitle"
              label="题目标题"
              header-align="center"
              align="left"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="subjectType"
              label="题目类型"
              header-align="center"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="producer"
              label="题目选项"
              header-align="center"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope"> {{ getSelectItems(scope.row.selectItems) }} </template>
            </el-table-column>
            <el-table-column
              prop="subjectItemType"
              label="题型分类"
              header-align="center"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope"> {{ scope.row.subjectItemType | commonFilterName('题型分类') }} </template>
            </el-table-column>
            <el-table-column
              width="150"
              prop="updateTime"
              label="操作时间"
              header-align="center"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope"> {{ scope.row.updateTime | getTimeDate }} </template>
            </el-table-column>
            <el-table-column prop="price" label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <a class="txt-color" @click="editSubject(scope.row)">编辑 ｜</a>
                <a class="txt-color" @click="delSubject([scope.row.guid])">删除</a>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pt pb back-color-fff"
            background
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="pageII.pageIndex"
            :page-size="pageII.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="pageII.totalRows"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 弹窗-添加题目 -->
    <el-dialog width="960px" :title="textTitle" :visible.sync="subjectVisible" :close-on-click-modal="false">
      <!-- 手动添加题目 -->

      <div class="subject-title">
        <div class="subject-title-name"><span></span>问题基础配置</div>
      </div>
      <el-row :gutter="24">
        <el-col :span="12"
          ><div class="search-area-div" style="width: 102px; font-size: 14px">
            <span style="color: red">*</span>题目标题：
          </div>
          <el-input class="fl" type="textarea"
              :rows="2" style="width: 300px" placeholder="请输入" v-model="subjectForm.subjectTitle"></el-input>
        </el-col>
        <el-col :span="12"
          ><div class="search-area-div" style="width: 102px; font-size: 14px">
            <span style="color: red">*</span>题目类型：
          </div>
          <el-select style="width: 225px" class="fl" v-model="subjectForm.subjectType" @change="subjectTypeChange" filterable placeholder="请选择">
            <el-option
              v-for="(item, index) in subjectTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- 题型分类 / 字典名称 -->
      <el-row :gutter="24" class="mt15"
        v-if="subjectForm.subjectType == '单选题' || subjectForm.subjectType == '多选题'">
        <el-col :span="12"
          ><div class="search-area-div" style="width: 102px; font-size: 14px">
            <span style="color: red">*</span>题型分类：
          </div>
          <el-select
            style="width: 300px" class="fl"
            v-model="subjectForm.subjectItemType"
            @change="subjectItemTypeChange"
            filterable
            placeholder="请选择">
            <el-option
              v-for="(item, index) in getCodeListByKey('题型分类')"
              :key="index"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="12" v-if="subjectForm.subjectItemType == '4'"
          ><div class="search-area-div" style="width: 102px; font-size: 14px">
            <span style="color: red">*</span>字典名称：
          </div>
          <el-select
            style="width: 225px" class="fl"
            v-model="subjectForm.dictGuid"
            @change="dictChange"
            filterable
            placeholder="请选择">
            <el-option
              v-for="(item, index) in dictList"
              :key="index"
              :label="item.dictTypeName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- 交互方式 -->
      <el-row :gutter="24" class="mt15"
        v-if="subjectForm.subjectItemType == '1' || subjectForm.subjectItemType == '4'">
        <el-col :span="12"
          ><div class="search-area-div" style="width: 102px; font-size: 14px">
            <span style="color: red">*</span>交互方式：
          </div>
          <el-select
            style="width: 300px" class="fl"
            v-model="subjectForm.interactType"
            @change="interactTypeChange"
            filterable
            placeholder="请选择">
            <el-option
              v-for="(item, index) in getCodeListByKey('交互方式')"
              :key="index"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="12" v-if="subjectForm.interactType == '2' && subjectForm.hasChild" style="line-height: 36px;">
          <el-checkbox v-model="subjectForm.isSupportAll"></el-checkbox>
          <span class="ml10" style="color: red">支持选字典“全部”选项</span>
        </el-col>
      </el-row>
      <!-- 验证方式输入 / 唯一性校验 -->
      <el-row :gutter="24" class="mt15" v-if="subjectForm.subjectType == '选择区域'">
        <el-col :span="12"
          ><div class="search-area-div" style="width: 110px; font-size: 14px;margin-left: -8px;">
            <span style="color: red">*</span>验证方式输入：
          </div>
          <el-select
            style="width: 300px" class="fl"
            v-model="subjectForm.validateGuid"
            filterable
            placeholder="请选择">
            <el-option
              v-for="item in validateList"
              :key="item.validateRuleGuid"
              :label="item.validName"
              :value="item.validateRuleGuid"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-if="subjectForm.subjectType == '单行填空题' || subjectForm.subjectType == '年月' || subjectForm.subjectType == '年月日' || subjectForm.subjectType == '填写日期' || subjectForm.subjectType == '定位签到'">
        <el-col :span="12"
          ><div class="search-area-div" style="width: 110px; font-size: 14px;margin-left: -8px;">
            <span style="color: red">*</span>验证方式输入：
          </div>
          <el-select
            style="width: 300px" class="fl"
            v-model="subjectForm.validateGuid"
            filterable
            placeholder="请选择">
            <el-option
              v-for="item in validateList"
              :key="item.validateRuleGuid"
              :label="item.validName"
              :value="item.validateRuleGuid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="12"
          class="flex items_center"
          ><div class="search-area-div" style="width: 110px; font-size: 14px">
            <el-popover trigger="hover" width="260" placement="top-start">
              <div>如果该问卷收集的此项内容不允许重复，可开启这个校验。</div>
              <template slot="reference">
                <i class="el-icon-question"></i>
              </template>
            </el-popover>
            <span style="color: red">*</span>唯一性校验：
          </div>
          <el-radio-group v-model="subjectForm.isValidateUnique">
            <el-radio label="Y">校验</el-radio>
            <el-radio label="N">不校验</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15">
        <el-col :span="12"
          ><div class="search-area-div" style="width: 102px; font-size: 14px">
            <span style="color: red">*</span>题目标签：
          </div>
          <el-cascader
            :key="subjectLabelCascaderKey"
            style="width: 300px" class="fl"
            v-model="subjectForm.subjectLabelGuid"
            :options="labelList"
            filterable
            :show-all-levels="false"
            :props="{
              value: 'guid',
              label: 'labelName',
              children: 'children',
              multiple: false,
              emitPath: false,
            }"
            clearable
            placeholder="请选择"
          >
          </el-cascader>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15"
        v-if="subjectForm.subjectType && subjectForm.subjectType.indexOf('上传照片') > -1"
        >
        <el-col :span="24"
          ><div class="search-area-div" style="width: 110px; font-size: 14px">
            <el-popover trigger="hover" width="300" placement="right-start">
              <div>{{ '用于提供给终端服务人员在做任务时的参考图' }}</div>
              <template slot="reference">
                <i class="el-icon-question"></i>
              </template>
            </el-popover>
            示例图片：
          </div>
          <div class="dialogCon-describe file-list-box">
            <el-upload
              class="upload-file-box"
              action="#"
              :limit="5"
              :headers="token"
              :on-exceed="handleExceed"
              accept=".jpg,.png,.jpeg"
              :on-remove="handleBillRemove"
              :http-request="uploadBillImage"
              :file-list="subjectForm.pictUrl"
            >
              <div class="import-btn-tips">
                <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                  >点击上传</el-button
                >
                <div slot="tip" class="import-step-tip">
                  {{ '最大不超过 5M 的图片，支持jpg、png、jpeg等图片格式' }}
                </div>
              </div>
              <div slot="file" slot-scope="{ file }" v-show="false">
              </div>
            </el-upload>
          </div>
        </el-col>
      </el-row>
      <div class="picture-box" v-if="subjectForm.pictUrl && subjectForm.pictUrl.length > 0">
        <div class="flex" v-for="(file, fileIndex) in subjectForm.pictUrl" :key="fileIndex">
          <div class="file-name nowrap-ellipsis">{{ file.fileName }}</div>
          <div class="flex">
            <a
              @click="handlePictureCardPreview(file)"
              style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
              class="downFile"
              >查看</a
            >
            <a
              @click="handleBillRemove(file)"
              style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
              class="downFile"
              >删除</a
            >
          </div>
        </div>
      </div>
      <div
        class="subject-title mt30"
        v-show="showSelectItemsConfig"
      >
        <div class="subject-title-name"><span></span>题目选项配置</div>
        <div class="subject-add-btn" v-if="subjectForm.subjectItemType !== '4'" @click="addSubjectItem">
          <span>+</span>
          添加选项
        </div>
      </div>
      <el-table
        :data="subjectForm.selectItems"
        style="width: 100%"
        v-show="showSelectItemsConfig"
      >
        <template slot="empty">
          <span >暂无选项</span>
        </template>
        <el-table-column label="序号" width="70">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="选项名称">
          <template slot-scope="scope">
            <el-select v-if="subjectForm.subjectType == '调研对象'" class="fl" v-model="scope.row.value" @change="changeSubjectObj(scope.row)" placeholder="请选择" style="width: 70%;">
              <el-option
                v-for="item in targetOption"
                :key="item.value"
                :label="item.label || item.text"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select v-else-if="subjectForm.subjectItemType == '4'" class="fl" disabled v-model="scope.row.value" placeholder="请选择" style="width: 70%;">
              <el-option
                v-for="item in targetOption"
                :key="item.value"
                :label="item.text"
                :value="item.value">
              </el-option>
            </el-select>
            <el-input v-else class="fl" type="input" placeholder="请输入" v-model="scope.row.text" style="width: 70%;" />
          </template>
        </el-table-column>
        <el-table-column
          v-if="(subjectForm.subjectType == '单选题' || subjectForm.subjectType == '多选题') && (subjectForm.subjectItemType=='1'||subjectForm.subjectItemType=='4') && subjectForm.interactType=='1'"
          prop="address"
          label="是否追加子答案项"
          width="180">
          <template slot-scope="scope">
            <div class="subject-select">
              <el-checkbox @change="addChange(scope.row)" v-model="scope.row.isAdd">追加</el-checkbox>
              <el-checkbox :disabled="!scope.row.isAdd" v-model="scope.row.isAddWrite">必填</el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="150">
          <template slot-scope="scope">
            <div class="opreateIcon">
              <i
                v-if="scope.$index + 1 != subjectForm.selectItems.length"
                class="el-icon-sort-down"
                @click="sortDownField('field', scope.row, scope.$index)"
              ></i>
              <i
                v-if="scope.$index != 0"
                class="el-icon-sort-up"
                @click="sortUpField('field', scope.row, scope.$index)"
              ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="160">
          <template slot-scope="scope">
            <a class="txt-color" v-if="subjectForm.subjectItemType !== '4'" @click="subjectFieldDel(scope.$index)">删除 </a>
            <span class="txt-color" v-if="subjectForm.subjectItemType !== '4' && scope.row.isAdd">|</span>
            <a class="txt-color" v-if="scope.row.isAdd" @click="setSelectAdd(scope.row, scope.$index)"> 追加子答案规则</a>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="subjectVisible = false">取 消</el-button>
        <el-button size="medium" type="info" @click="subjectSubmit()" v-if="isEdit">修改</el-button>
        <el-button size="medium" type="info" @click="subjectSubmit()" v-else>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 弹窗-设置追加子答案规则 -->
    <el-dialog width="760px" custom-class="childDialog" :visible.sync="selectAddVisible">
      <div slot="title" style="text-align:left">
        <span class="dialog-title-active">追加子答案规则</span>
      </div>
      <el-row :gutter="24" class="mt15">
        <div class="search-area-div" style="width: 110px; font-size: 14px">
          <span style="color: red">*</span>题目类型：
        </div>
        <el-select
          class="fl"
          v-model="childForm.subjectType"
          filterable
          placeholder="请选择"
          @change="childTypeChange"
        >
          <el-option
            v-for="(item, index) in childTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-row>
      <el-row :gutter="24" class="mt15" v-if="childForm.subjectType == '单选题' || childForm.subjectType == '多选题'">
        <div class="search-area-div" style="width: 110px; font-size: 14px">
          <span style="color: red">*</span>题型分类：
        </div>
        <el-select
          class="fl"
          v-model="childForm.subjectItemType"
          filterable
          placeholder="请选择"
          @change="subjectItemTypeChange('child')"
        >
          <el-option
            v-for="(item, index) in getCodeListByKey('题型分类')"
            :key="index"
            :label="item.text"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-row>
      <el-row :gutter="24" class="mt15" v-if="(childForm.subjectType == '单选题' || childForm.subjectType == '多选题') && childForm.subjectItemType == '4'">
        <div class="search-area-div" style="width: 110px; font-size: 14px">
          <span style="color: red">*</span>字典名称：
        </div>
        <el-select
          class="fl"
          v-model="childForm.dictGuid"
          filterable
          placeholder="请选择"
          @change="dictChange(childForm.dictGuid, 'child')"
        >
          <el-option
            v-for="(item, index) in dictList"
            :key="index"
            :label="item.dictTypeName"
            :value="item.guid"
          ></el-option>
        </el-select>
        <div v-if="childForm.interactType == '2' && childForm.hasChild" class="fl ml10" style="line-height: 36px;">
          <el-checkbox v-model="childForm.isSupportAll"></el-checkbox>
          <span class="ml10" style="color: red">支持选字典“全部”选项</span>
        </div>
      </el-row>
      <el-row :gutter="24" class="mt15" v-if="(childForm.subjectType == '单选题' || childForm.subjectType == '多选题') && (childForm.subjectItemType == '1' || childForm.subjectItemType == '4')">
        <div class="search-area-div" style="width: 110px; font-size: 14px">
          <span style="color: red">*</span>交互方式：
        </div>
        <el-select
          class="fl"
          v-model="childForm.interactType"
          filterable
          @change="interactTypeChange('child')"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in getCodeListByKey('交互方式')"
            :key="index"
            :label="item.text"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-row>
      <el-row :gutter="24" class="mt15"
        v-if="childForm.subjectType == '单行填空题' ||
        childForm.subjectType == '年月' ||
        childForm.subjectType == '年月日' ||
        childForm.subjectType == '定位签到'"
      >
        <div class="search-area-div" style="width: 110px; font-size: 14px">
          <span style="color: red">*</span>验证输入方式：
        </div>
        <el-select
          class="fl"
          v-model="childForm.validateGuid"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in validateList"
            :key="item.validateRuleGuid"
            :label="item.validName"
            :value="item.validateRuleGuid"
          ></el-option>
        </el-select>
      </el-row>
      <el-row :gutter="24" class="mt15" v-if="childForm.subjectType == '单行填空题' || childForm.subjectType == '多行填空题'">
        <div class="search-area-div" style="width: 110px; font-size: 14px">
          <span style="color: red">*</span>提示语：
        </div>
        <el-input v-model.trim="childForm.cueWords" class="fl" style="width: 225px;"></el-input>
      </el-row>
      <div
        class="subject-title mt30"
        v-show="(childForm.subjectType == '单选题' || childForm.subjectType == '多选题') && (childForm.subjectItemType == '1' || childForm.subjectItemType == '4')"
      >
        <div class="subject-title-name"><span></span>子答案选项配置</div>
        <div class="subject-add-btn" v-if="childForm.subjectItemType !== '4'" @click="addChildItem">
          <span>+</span>
          添加选项
        </div>
      </div>
      <el-table
        :data="childForm.selectItems"
        style="width: 100%"
        v-show="(childForm.subjectType == '单选题' || childForm.subjectType == '多选题') && (childForm.subjectItemType == '1' || childForm.subjectItemType == '4')"
      >
        <template slot="empty">
          <span>暂无选项</span>
        </template>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="选项名称">
          <template slot-scope="scope">
            <el-select
              v-if="childForm.subjectItemType == '4'"
              class="fl"
              disabled
              v-model="scope.row.value"
              placeholder="请选择"
            >
              <el-option v-for="item in childTargetOption" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
            <el-input v-else class="fl" type="input" placeholder="请输入" v-model.trim="scope.row.text" />
          </template>
        </el-table-column>
        <el-table-column v-if="childForm.subjectItemType == '1'" label="排序" width="100">
          <template slot-scope="scope">
            <div class="opreateIcon">
              <i
                v-if="scope.$index + 1 != childForm.selectItems.length"
                class="el-icon-sort-down"
                @click="sortDownField('child', scope.row, scope.$index)"
              ></i>
              <i
                v-if="scope.$index != 0"
                class="el-icon-sort-up"
                @click="sortUpField('child', scope.row, scope.$index)"
              ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="childForm.subjectItemType == '1'" prop="address" label="操作" width="100">
          <template slot-scope="scope">
            <a class="txt-color" @click="subjectFieldDel(scope.$index, 'child')">删除</a>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="info" @click="selectAddSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <LabelDialog
      :title="labelFormTitle"
      :visible.sync="labelVisible"
      :form="labelForm"
      :label-list="labelList"
      @submit="handleLabelSubmit"
    />
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import LabelDialog from './components/LabelDialog.vue';
import { cloneDeep } from 'lodash';
import { SelectItemsValue, SelectQuestionType } from './enum';
export default {
  components: {
    LabelDialog,
  },
  data() {
    return {
      page: {
        pageIndex: 1,
        pageSize: 10,
        labelName: '',
        totalRows: 0,
        totalPage: 0,
      },
      labelList:[],
      tableData: [],
      labelName: '',

      pageII: {
        pageIndex: 1,
        pageSize: 10,
        subjectTitle: '',
        subjectType: '',
        subjectItemType: '',
        labelGuid: null,
        totalRows: 0,
        totalPage: 0,
        labelName: '',
      },
      subjectTypeList: [
        {
          label: '单选题',
          value: '单选题',
        },
        {
          label: '多选题',
          value: '多选题',
        },
        {
          label: '单行填空题',
          value: '单行填空题',
        },
        {
          label: '多行填空题',
          value: '多行填空题',
        },
        {
          label: '选择区域',
          value: '选择区域',
        },
        {
          label: '调研对象',
          value: '调研对象',
        },
        {
          label: '客户名称',
          value: '客户名称',
        },
        {
          label: '年月',
          value: '年月',
        },
        {
          label: '年月日',
          value: '年月日',
        },
        {
          label: '时间',
          value: '时间',
        },
        {
          label: '填写日期',
          value: '填写日期',
        },
        {
          label: '定位签到',
          value: '定位签到',
        },
        {
          label: '上传照片(拍照带水印)',
          value: '上传照片(拍照带水印)',
        },
        {
          label: '上传照片(拍照不带水印)',
          value: '上传照片(拍照不带水印)',
        },
        {
          label: '选择医疗机构',
          value: '选择医疗机构',
        },
        {
          label: '选择等级医院',
          value: '选择等级医院',
        },
        {
          label: '选择基层医疗',
          value: '选择基层医疗',
        },
        {
          label: '选择药店',
          value: '选择药店',
        },
        {
          label: '选择商业公司',
          value: '选择商业公司',
        },
      ],
      childTypeList: [
        {
          label: '单选题',
          value: '单选题',
        },
        {
          label: '多选题',
          value: '多选题',
        },
        {
          label: '单行填空题',
          value: '单行填空题',
        },
        {
          label: '多行填空题',
          value: '多行填空题',
        },
        {
          label: '选择区域',
          value: '选择区域',
        },
        {
          label: '年月',
          value: '年月',
        },
        {
          label: '年月日',
          value: '年月日',
        },
        {
          label: '时间',
          value: '时间',
        },
        {
          label: '定位签到',
          value: '定位签到',
        },
        {
          label: '选择医疗机构',
          value: '选择医疗机构',
        },
        {
          label: '选择等级医院',
          value: '选择等级医院',
        },
        {
          label: '选择基层医疗',
          value: '选择基层医疗',
        },
        {
          label: '选择药店',
          value: '选择药店',
        },
        {
          label: '选择商业公司',
          value: '选择商业公司',
        },
      ],
      productInformationList: [],
      reserrveSelection: true,
      multipleSelection: [],
      targetOption:[],//调研对象下拉
      childTargetOption:[],//子答案字典下拉
      dictList: [],       // 字典名称下拉
      validateList: [],   // 验证方式下拉
      oldSubjectType: '', // 用于单选/多选切换时保留选项
      oldChildType: '',   // 用于子答案单选/多选切换时保留选项
      subjectVisible: false,
      selectAddVisible: false, // 追加子答案规则弹窗
      subjectForm: {
        subjectTitle: '',
        subjectType: '',
        orderNum: '',
        isRequired: 'Y',
        inputText: '',
        otherInput: null,
        valueSelect: [],
        selectItems: [],
        subjectLabelGuid:null,
        subjectItemType: '',   // 题型分类
        dictGuid: '',          // 字典名称
        dictName: '',          // 字典名称文本
        interactType: '',      // 交互方式
        validateGuid: '',      // 验证方式输入
        isValidateUnique: 'N', // 唯一性校验
        hasChild: false,       // 字典是否有二级
        isSupportAll: false,   // 支持选字典“全部”
      },
      childForm: {
        subjectType: '',
        inputText: '',
        valueSelect: [],
        selectItems: [],
        isValidateUnique: 'N',//校验唯一性
        validateGuid:"", //验证方式
        subjectItemType:'',//题型分类
        dictGuid:'',//字典名称
        dictName:'',//字典名称
        interactType:'',//交互类型
        cueWords:'',//提示语
        index:null,
        hasChild:false,//是否二级字典
        isSupportAll:false,//支持全部
      },
      isEdit: false,
      labelVisible: false,
      labelFormTitle: '新增题目标签',
      labelForm: {
        labelName: '',
        parentGuid: '',
        sort: '',
        bizState: 'Y'
      },
      labelFormRules: {
        labelName: [{ required: true, message: '请填写标签名称', trigger: 'blur' }],
        bizState: [{ required: true, message: '请选择启用状态', trigger: 'change' }]
      },

      conHeight: window.innerHeight - 85,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },

      paramName: '',
      textTitle: '新增题目',
      fullscreenLoading: false,
      currentIndex: 0,
      showMore: false,

      // 树结构配置
      treeProps: {
        label: 'labelName',
        children: 'children'
      },
      currentLabelGuid: '',
      expandedKeys: [],
      subjectLabelCascaderKey: 0,
    };
  },
  computed: {
    showSelectItemsConfig() {
      if (this.subjectForm.subjectType == '调研对象') return true;
      if (
        this.subjectForm.subjectType == '单选题' ||
        this.subjectForm.subjectType == '多选题'
      ) {
        return (
          this.subjectForm.subjectItemType == '1' ||
          this.subjectForm.subjectItemType == '4'
        );
      }
      return false;
    }
  },
  watch: {
    selectAddVisible: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal == true) {
          this.subjectVisible = false;
        } else if (oldVal == true && newVal == false) {
          this.subjectVisible = true;
        }
      }
    }
  },
  created() {
    this.getList();
    this.getDictList();
  },

  methods: {
    // 点击导航菜单，页面滚动到指定位置
    handleLeft(detail) {
      let self = this;
      self.pageII.pageIndex = 1;
      self.multipleSelection = [];
      self.pageII.labelGuid = detail.guid;
      self.pageII.labelName = detail.labelName;
      self.currentLabelGuid = detail.guid;
      self.getData();
    },
    handleTreeCommand(command, data) {
      if (command === 'edit') {
        this.editLabel(data);
      } else if (command === 'del') {
        this.delVersion(data.guid);
      }
    },

    getList(type) {
      if (type) {
        this.page.pageIndex = 1;
      }
      let self = this;
      self.fullscreenLoading = true;
      let query = {
        labelName: self.page.labelName,
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/subject-stock/label/get-tree`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.getAllLabel();
          self.tableData = res.data.data;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
          self.tableData.forEach((el) => {
            el.is_edit = false;
          });
          if (self.tableData.length != 0) {
            self.pageII.pageIndex = 1;
            // 当前没有选中标签时,默认选中第一个
            if (!self.currentLabelGuid) {
              self.pageII.labelGuid = self.tableData[0].guid;
              self.pageII.labelName = self.tableData[0].labelName;
              self.currentLabelGuid = self.tableData[0].guid;
            }
            self.expandedKeys = [self.currentLabelGuid];
            self.$nextTick(() => {
              self.$refs.labelTree.setCurrentKey(self.currentLabelGuid);
            });
            self.getData();
          } else {
            self.currentLabelGuid = '';
            self.pageII.labelGuid = null;
            self.pageII.labelName = '';
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 获取所有标签
    getAllLabel(){
      let self = this;
      let query = {
        bizState: 'Y',
        pageIndex:1,
        pageSize:-1
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/subject-stock/label/get-tree`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.labelList = res.data.data;
          
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 获取字典分类
    getDictList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
      };
      self.api.postJson(`/${serverConfig.msConfigureService}/dict/data/get-class-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dictList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 获取验证方式
    getValidateList(subjectType) {
      let self = this;
      let query = {
        subjectType: subjectType,
      };
      self.api.postJson(`/${serverConfig.msConfigureService}/subject-validate-rule/get-subject-rule`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.validateList = res.data.data || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 字典名称切换
    dictChange(val, type) {
      let dict = this.dictList.find((item) => item.guid == val);
      let dictName = dict ? dict.dictTypeName : '';
      let data = this.getCodeListByKey(dictName);
      let newArr = [];
      if (data && data.length) {
        newArr = data.map((i, index) => ({
          text: i.text,
          value: i.value,
          orderNum: index + 1,
          isCorrect: null,
          isAdd: false,
          isAddWrite: false,
          subjectItem: null,
          child: i.childDictList || null,
        }));
      }
      if (type == 'child') {
        this.childForm.dictName = dictName;
        this.childTargetOption = data || [];
        this.childForm.selectItems = newArr;
        this.childForm.hasChild = this.hasChildArray(val);
      } else {
        this.subjectForm.dictName = dictName;
        this.targetOption = data || [];
        this.subjectForm.selectItems = newArr;
        this.subjectForm.hasChild = this.hasChildArray(val);
      }
    },
    // 判断字典是否有二级
    hasChildArray(val) {
      let dict = this.dictList.find((item) => item.guid == val);
      let data = this.getCodeListByKey(dict ? dict.dictTypeName : '');
      return data.some((item) => Array.isArray(item.childDictList) && item.childDictList.length);
    },
    // 题型分类切换
    subjectItemTypeChange(type) {
      if (type == 'child') {
        this.childForm.selectItems = [];
        this.childForm.interactType = '';
        this.childForm.dictName = '';
        this.childForm.dictGuid = '';
        this.childForm.hasChild = false;
        this.childForm.isSupportAll = false;
      } else {
        this.subjectForm.dictGuid = '';
        this.subjectForm.dictName = '';
        this.subjectForm.interactType = '';
        this.subjectForm.selectItems = [];
        this.subjectForm.hasChild = false;
        this.subjectForm.isSupportAll = false;
      }
    },
    // 交互方式切换
    interactTypeChange(type) {
      if (type == 'child') {
        if (this.childForm.selectItems && this.childForm.selectItems.length > 0) {
          this.childForm.selectItems.forEach((item) => {
            item.isAdd = false;
            item.isAddWrite = false;
          });
        }
        if (this.childForm.interactType !== '2') {
          this.childForm.isSupportAll = false;
        }
      } else {
        if (this.subjectForm.selectItems && this.subjectForm.selectItems.length > 0) {
          this.subjectForm.selectItems.forEach((item) => {
            item.isAdd = false;
            item.isAddWrite = false;
            item.subjectItem = null;
          });
        }
        if (this.subjectForm.interactType !== '2') {
          this.subjectForm.isSupportAll = false;
        }
      }
    },
    // 调研对象选项切换同步 text
    changeSubjectObj(row) {
      let item = this.targetOption.find((i) => i.value == row.value);
      if (item) row.text = item.text || item.label;
    },
    add() {
      this.labelFormTitle = '新增题目标签';
      this.labelForm = {
        labelName: '',
        parentGuid: '',
        sort: '',
        bizState: 'Y'
      };
      this.guid = '';
      this.labelVisible = true;
    },
    editLabel(detail) {
      this.labelFormTitle = '编辑题目标签';
      this.guid = detail.guid;
      this.labelForm = {
        labelName: detail.labelName,
        parentGuid: detail.parentGuids && detail.parentGuids.length > 0 ? detail.parentGuids[0] : '',
        sort: detail.sort,
        bizState: detail.bizState || 'Y'
      };
      this.labelVisible = true;
    },
    labelSubmit() {
      this.$refs.labelForm.validate((valid) => {
        if (!valid) return;
        this.updateReqVersion();
      });
    },
    handleLabelSubmit() {
      this.updateReqVersion();
    },
    edit(detail, index, type) {
      if (type == 0) {
        this.tableData[index].is_edit = true;
        this.guid = detail.guid;
        this.labelName = detail.labelName;
        this.$forceUpdate();
      } else {
        this.updateReqVersion();
      }
    },
    delVersion(guid) {
      var self = this;
      var req = [guid];
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/subject-stock/label/del`, req).then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              if (this.currentLabelGuid == guid) {
                this.currentLabelGuid = '';
              }
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    // 把新增字段挂到每个选项的 subjectItem 上（无选项题型用一个占位项）
    buildSelectItemsWithSubjectItem() {
      let subjectItemCfg = {
        subjectType: this.subjectForm.subjectType,
        isValidateUnique: this.subjectForm.isValidateUnique,
        validateGuid: this.subjectForm.validateGuid,
        subjectItemType: this.subjectForm.subjectItemType,
        dictGuid: this.subjectForm.dictGuid,
        dictName: this.subjectForm.dictName,
        isSupportAll: this.subjectForm.isSupportAll,
        interactType: this.subjectForm.interactType,
      };

      let items =
        this.subjectForm.selectItems && this.subjectForm.selectItems.length
          ? this.subjectForm.selectItems
          : [{ text: '', value: '', orderNum: '', isCorrect: null }];

      return items.map((item) => {
        // 若该选项已配置子答案，保留子答案配置，不再覆盖为主题目配置
        if (item.isAdd && item.subjectItem && item.subjectItem.subjectType) {
          return { ...item };
        }
        return {
          ...item,
          subjectItem: {
            ...(item.subjectItem || {}),
            ...subjectItemCfg,
          },
        };
      });
    },
    addSubjectReq() {
      var self = this;
      let selectItems = this.buildSelectItemsWithSubjectItem();
      var req = {
        subjectLabelGuid: this.subjectForm.subjectLabelGuid,
        subjectTitle: this.subjectForm.subjectTitle,
        subjectType: this.subjectForm.subjectType,
        isRequired: this.subjectForm.isRequired,
        orderNum: this.subjectForm.orderNum,
        selectItems: selectItems,
        tenantGuid: localStorage.guid,
        // 题目级配置同时放在顶层，便于后端与子答案区分
        subjectItemType: this.subjectForm.subjectItemType,
        dictGuid: this.subjectForm.dictGuid,
        dictName: this.subjectForm.dictName,
        interactType: this.subjectForm.interactType,
        validateGuid: this.subjectForm.validateGuid,
        isValidateUnique: this.subjectForm.isValidateUnique,
        isSupportAll: this.subjectForm.isSupportAll,
        pictUrl: this.subjectForm.pictUrl || [],
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/subject-stock/subject/add`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('新增成功');
          this.subjectVisible = false;
          this.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateSubjectReq() {
      var self = this;
      let selectItems = this.buildSelectItemsWithSubjectItem();
      var req = {
        subjectLabelGuid: this.subjectForm.subjectLabelGuid,
        subjectTitle: this.subjectForm.subjectTitle,
        subjectType: this.subjectForm.subjectType,
        isRequired: this.subjectForm.isRequired,
        orderNum: this.subjectForm.orderNum,
        selectItems: selectItems,
        guid: this.subjectGuid,
        tenantGuid: localStorage.guid,
        // 题目级配置同时放在顶层，便于后端与子答案区分
        subjectItemType: this.subjectForm.subjectItemType,
        dictGuid: this.subjectForm.dictGuid,
        dictName: this.subjectForm.dictName,
        interactType: this.subjectForm.interactType,
        validateGuid: this.subjectForm.validateGuid,
        isValidateUnique: this.subjectForm.isValidateUnique,
        isSupportAll: this.subjectForm.isSupportAll,
        pictUrl: this.subjectForm.pictUrl || [],
      };
      self.fullscreenLoading = true;
      self.api.put(`/${serverConfig.msSalesPerformService}/subject-stock/subject/update`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('修改成功');
          this.subjectVisible = false;
          this.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      var self = this;
      let req = {
        labelName: this.labelForm.labelName,
        tenantGuid: localStorage.guid,
        parentGuid: this.labelForm.parentGuid || null,
        sort: this.labelForm.sort || null,
        bizState: this.labelForm.bizState
      };
      if (this.guid) {
        req.guid = this.guid;
      }

      self.fullscreenLoading = true;

      if (this.guid) {
        self.api.put(`/${serverConfig.msSalesPerformService}/subject-stock/label/update`, req).then((res) => {
          self.fullscreenLoading = false;
          self.labelVisible = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('修改成功');
            self.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      } else {
        self.api.postJson(`/${serverConfig.msSalesPerformService}/subject-stock/label/add`, req).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.labelVisible = false;
            self.$message.success('新增成功');
            self.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    getData(type) {
      if (type) {
        this.pageII.pageIndex = 1;
      }
      let self = this;
      self.fullscreenLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/subject-stock/subject/list`, this.pageII)
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.productInformationList = res.data.data.records;
            self.pageII.totalPage = res.data.data.totalPages;
            self.pageII.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    
    getSelectItems(list) {
      var str = '';
      if (list && list.length) {
        list.forEach((item, index) => {
          str = str + item.text + '、';
        });
        var reg = /、$/gi;
        str = str.replace(reg, '');
      }
      return str || '-';
    },
    handleSizeChange1(val) {
      let self = this;
      self.pageII.pageSize = val;
      this.getData();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.pageII.pageIndex = val;
      this.getData();
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = val;
    },
    // btn(row, col, event) {
    //   row.flag = !row.flag;
    //   this.$refs.dataTable.toggleRowSelection(row, row.flag);
    // },
    emptySearch() {
      this.pageII.subjectTitle = '';
      this.pageII.subjectType = '';
      this.pageII.subjectItemType = '';
      this.getData(true);
    },
    delSubject(req) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/subject-stock/subject/del`, req).then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.getData();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    allDel() {
      console.log(this.multipleSelection);
      if (this.multipleSelection.length == 0) {
        this.$message.error('请勾选需要删除的题目！');
        return;
      }
      var guids = [];
      this.multipleSelection.forEach((item) => {
        guids.push(item.guid);
      });
      this.delSubject(guids);
    },
    //题目-修改题目
    editSubject(detail) {
      console.log(detail);
      this.textTitle = '修改题目';
      this.subjectGuid = detail.guid;
      this.isEdit = true;
      this.subjectForm = {
        subjectTitle: detail.subjectTitle,
        subjectType: detail.subjectType,
        orderNum: detail.orderNum,
        isRequired: detail.isRequired,
        inputText: detail.inputText,
        otherInput: null,
        valueSelect: [],
        selectItems: detail.selectItems || [],
        subjectLabelGuid: detail.subjectLabelGuid,
        subjectItemType: detail.subjectItemType || '',
        dictGuid: detail.dictGuid || '',
        dictName: detail.dictName || '',
        interactType: detail.interactType || '',
        validateGuid: detail.validateGuid || '',
        isValidateUnique: detail.isValidateUnique || 'N',
        hasChild: false,
        isSupportAll: detail.isSupportAll || false,
        pictUrl: detail.pictUrl || [],
      };

      // 题目级配置优先取顶层字段，否则从非子答案选项的 subjectItem 中读取，最后兜底 selectItems[0].subjectItem
      let selectItems = detail.selectItems || [];
      let firstNoChildCfg = selectItems.find((item) =>
        !item.isAdd || !(item.subjectItem && item.subjectItem.subjectType)
      );
      let itemCfg =
        firstNoChildCfg?.subjectItem ||
        (selectItems[0] && selectItems[0].subjectItem) ||
        {};
      this.subjectForm.subjectItemType = itemCfg.subjectItemType || this.subjectForm.subjectItemType;
      this.subjectForm.dictGuid = itemCfg.dictGuid || this.subjectForm.dictGuid;
      this.subjectForm.dictName = itemCfg.dictName || this.subjectForm.dictName;
      this.subjectForm.interactType = itemCfg.interactType || this.subjectForm.interactType;
      this.subjectForm.validateGuid = itemCfg.validateGuid || this.subjectForm.validateGuid;
      this.subjectForm.isValidateUnique = itemCfg.isValidateUnique || this.subjectForm.isValidateUnique;
      this.subjectForm.isSupportAll = itemCfg.isSupportAll || this.subjectForm.isSupportAll;

      // 处理子答案回显：补充默认值、初始化字典选项
      this.subjectForm.selectItems.forEach((item) => {
        item.isAdd = !!item.isAdd;
        item.isAddWrite = !!item.isAddWrite;
        if (!item.isAdd) {
          item.subjectItem = null;
        }
        if (item.isAdd && item.subjectItem && item.subjectItem.subjectItemType == '4' && item.subjectItem.dictGuid) {
          let dict = this.dictList.find((d) => d.guid == item.subjectItem.dictGuid);
          if (dict) {
            item.subjectItem.hasChild = this.hasChildArray(item.subjectItem.dictGuid);
            this.childTargetOption = this.getCodeListByKey(dict.dictTypeName);
          }
        }
      });

      if (detail.subjectType) {
        this.getValidateList(detail.subjectType);
      }
      if (this.subjectForm.subjectItemType == '4' && this.subjectForm.dictGuid) {
        let dict = this.dictList.find((item) => item.guid == this.subjectForm.dictGuid);
        if (dict) {
          this.targetOption = this.getCodeListByKey(dict.dictTypeName);
          this.subjectForm.hasChild = this.hasChildArray(this.subjectForm.dictGuid);
        }
      }
      if (detail.subjectType == '调研对象') {
        this.getTargetList();
      }
      this.oldSubjectType = detail.subjectType;

      this.subjectVisible = true;
    },
    // 根据当前左侧选中的标签，获取添加题目时默认使用的题目标签（有子类则取第一个子类）
    getDefaultSubjectLabelGuid() {
      const guid = this.currentLabelGuid;
      if (!guid) return null;
      const findNode = (list, targetGuid) => {
        for (const item of list) {
          if (item.guid === targetGuid) return item;
          if (item.children && item.children.length) {
            const found = findNode(item.children, targetGuid);
            if (found) return found;
          }
        }
        return null;
      };
      const node = findNode(this.labelList, guid);
      if (node && node.children && node.children.length) {
        return node.children[0].guid;
      }
      return guid;
    },
    //题目-添加题目
    addSubject() {
      this.textTitle = '添加题目';
      this.subjectVisible = true;
      this.isEdit = false;
      this.oldSubjectType = '';
      this.oldChildType = '';
      this.subjectForm = {
        subjectTitle: '',
        subjectType: '',
        orderNum: '',
        isRequired: 'Y',
        inputText: '',
        otherInput: null,
        valueSelect: [],
        selectItems: [],
        subjectLabelGuid: this.getDefaultSubjectLabelGuid(),
        subjectItemType: '',
        dictGuid: '',
        dictName: '',
        interactType: '',
        validateGuid: '',
        isValidateUnique: 'N',
        hasChild: false,
        isSupportAll: false,
        pictUrl: [],
      };
      this.childForm = {
        subjectType: '',
        inputText: '',
        valueSelect: [],
        selectItems: [],
        isValidateUnique: 'N',
        validateGuid: '',
        subjectItemType: '',
        dictGuid: '',
        dictName: '',
        interactType: '',
        cueWords: '',
        index: null,
        hasChild: false,
        isSupportAll: false,
      };
      // 强制重新渲染题目标签级联选择器，避免面板缓存旧数据
      this.subjectLabelCascaderKey += 1;
    },
    //添加题目选项
    addSubjectItem() {
      let obj = {
        text: '',
        orderNum: '',
        value: '',
        isCorrect: null,
      };
      if(this.subjectForm.subjectType == '单选题'&&this.subjectForm.selectItems.length>0){
        let flg = this.subjectForm.selectItems.some(m=>{return m.isCorrect == true})
        if(flg){
          obj.isCorrect =  false;
        }
      }
      if (this.subjectForm.subjectType !== '调研对象') {
        obj.isAdd = false;
        obj.isAddWrite = false;
        obj.inputText = '';
        obj.subjectItem = null;
      }
      this.subjectForm.selectItems.push(obj);
    },
    //题目选项-选择题目答案
    subjectIsTrue(type, index) {
      if (type === 1) {
        this.subjectForm.selectItems[index].isCorrect = true;
      } else {
        this.subjectForm.selectItems[index].isCorrect = false;
      }
      if(this.subjectForm.subjectType == '单选题'){
        this.subjectForm.selectItems.forEach((i,index1)=>{
          if(type === 1&&index !== index1){
            i.isCorrect = false;
          }
          if(i.isCorrect){
            i.correctText = i.text;
          }
        })
      }
    },
    // 是否追加子答案
    addChange(row) {
      row.subjectItem = null;
      row.isAddWrite = false;
      this.$forceUpdate();
    },
    // 子答案的题目类型切换
    childTypeChange(val) {
      let flg = this.oldChildType && ((this.oldChildType == '单选题' && val == '多选题') || (this.oldChildType == '多选题' && val == '单选题'));
      if (!flg) {
        this.childForm.isValidateUnique = 'N';
        this.childForm.selectItems = [];
        this.childForm.validateGuid = '';
        this.childForm.dictGuid = '';
        this.childForm.dictName = '';
        this.childForm.interactType = '';
        this.childForm.cueWords = '';
        this.childForm.subjectItemType = '';
        this.childForm.hasChild = false;
        this.childForm.isSupportAll = false;
      } else {
        this.childForm.validateGuid = '';
        this.childForm.cueWords = '';
      }
      this.oldChildType = val;
      this.getValidateList(val);
    },
    // 添加子答案选项
    addChildItem() {
      let obj = {
        text: '',
        orderNum: '',
        value: '',
        isCorrect: null,
      };
      this.childForm.selectItems.push(obj);
    },
    // 题目选项-追加子答案规则
    setSelectAdd(row, idx) {
      if (row.subjectItem && row.subjectItem.subjectType) {
        this.childForm = {
          subjectType: row.subjectItem.subjectType,
          inputText: row.subjectItem.inputText || '',
          valueSelect: row.subjectItem.valueSelect || [],
          selectItems: row.subjectItem.selectItems || [],
          isValidateUnique: row.subjectItem.isValidateUnique || 'N',
          validateGuid: row.subjectItem.validateGuid || '',
          subjectItemType: row.subjectItem.subjectItemType || '',
          dictGuid: row.subjectItem.dictGuid || '',
          dictName: row.subjectItem.dictName || '',
          interactType: row.subjectItem.interactType || '',
          cueWords: row.subjectItem.cueWords || '',
          index: idx,
          hasChild: row.subjectItem.hasChild || false,
          isSupportAll: row.subjectItem.isSupportAll || false,
        };
      } else {
        this.childForm = {
          subjectType: '',
          inputText: '',
          valueSelect: [],
          selectItems: [],
          isValidateUnique: 'N',
          validateGuid: '',
          subjectItemType: '',
          dictGuid: '',
          dictName: '',
          interactType: '',
          cueWords: '',
          index: idx,
          hasChild: false,
          isSupportAll: false,
        };
      }
      this.oldChildType = row.subjectItem ? row.subjectItem.subjectType : '';
      if (this.childForm.subjectItemType == '4' && this.childForm.dictGuid) {
        this.childForm.hasChild = this.hasChildArray(this.childForm.dictGuid);
        let dict = this.dictList.find((item) => item.guid == this.childForm.dictGuid);
        if (dict) {
          this.childTargetOption = this.getCodeListByKey(dict.dictTypeName);
        }
      }
      if (this.childForm.subjectType) {
        this.getValidateList(this.childForm.subjectType);
      }
      this.selectAddVisible = true;
    },
    // 子答案的弹框提交
    selectAddSubmit() {
      try {
        if (!this.childForm.subjectType) {
          throw new Error('请选择题目类型');
        }
        if (this.childForm.subjectType == '单选题' || this.childForm.subjectType == '多选题') {
          if (!this.childForm.subjectItemType) {
            throw new Error('请选择题型分类');
          }
          if (this.childForm.subjectItemType == '4' && !this.childForm.dictGuid) {
            throw new Error('请选择字典名称');
          }
          if ((this.childForm.subjectItemType == '1' || this.childForm.subjectItemType == '4') && !this.childForm.interactType) {
            throw new Error('请选择交互方式');
          }
          if (this.childForm.subjectItemType == '1' && !this.childForm.selectItems.length) {
            throw new Error('请添加选项');
          }
          this.childForm.selectItems.forEach((item) => {
            if (item.text == '') {
              throw new Error('请填写选项名称');
            }
          });
          for (let i = 0; i < this.childForm.selectItems.length; i++) {
            for (let j = i + 1; j < this.childForm.selectItems.length; j++) {
              if (this.childForm.selectItems[i].text == this.childForm.selectItems[j].text) {
                throw new Error(this.childForm.selectItems[i].text + '，选项名称不能重复');
              }
            }
          }
        }
        if (
          this.childForm.subjectType == '单行填空题' ||
          this.childForm.subjectType == '年月' ||
          this.childForm.subjectType == '年月日' ||
          this.childForm.subjectType == '填写日期' ||
          this.childForm.subjectType == '定位签到'
        ) {
          if (!this.childForm.validateGuid) {
            throw new Error('请选择验证输入方式');
          }
        }
        if (this.childForm.subjectType == '单行填空题' || this.childForm.subjectType == '多行填空题') {
          if (!this.childForm.cueWords) {
            throw new Error('请填写提示语');
          }
        }
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      if (this.childForm.subjectType !== '单行填空题') {
        this.childForm.isValidateUnique = 'N';
      }
      let idx = this.childForm.index;
      const selectItem = cloneDeep(this.childForm);
      // 追加的子类 如果是 单选题 | 多选题  value 为空，需要给一个默认值
      selectItem.selectItems = selectItem.selectItems.map((item, index) => {
        let value = item.value;
        if (SelectQuestionType.includes(selectItem.subjectType) && !item.value) {
          value = SelectItemsValue[index];
        }
        return {
          ...item,
          value,
        };
      });
      this.subjectForm.selectItems[idx].subjectItem = selectItem;
      this.$forceUpdate();
      this.selectAddVisible = false;
    },
    //题目/题目选项排序-向下
    sortDownField(type, row, index) {
      let orderNumFlag = row.orderNum;
      if (type == 'field') {
        row.orderNum = this.subjectForm.selectItems[index + 1].orderNum;
        this.subjectForm.selectItems[index + 1].orderNum = orderNumFlag;
        this.subjectForm.selectItems.splice(index, 1);
        this.subjectForm.selectItems.splice(index + 1, 0, row);
      } else if (type == 'child') {
        this.childForm.selectItems.splice(index, 1);
        this.childForm.selectItems.splice(index + 1, 0, row);
      }
    },
    //题目/题目选项排序-向上
    sortUpField(type, row, index) {
      let orderNumFlag = row.orderNum;
      if (type == 'field') {
        row.orderNum = this.subjectForm.selectItems[index - 1].orderNum;
        this.subjectForm.selectItems[index - 1].orderNum = orderNumFlag;
        this.subjectForm.selectItems.splice(index, 1);
        this.subjectForm.selectItems.splice(index - 1, 0, row);
      } else if (type == 'child') {
        this.childForm.selectItems[index - 1].orderNum = orderNumFlag;
        this.childForm.selectItems.splice(index, 1);
        this.childForm.selectItems.splice(index - 1, 0, row);
      }
    },
    //题目选项-删除
    subjectFieldDel(index, type) {
      this.$confirm('删除后不可恢复，确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (type == 'child') {
          this.childForm.selectItems.splice(index, 1);
        } else {
          this.subjectForm.selectItems.splice(index, 1);
        }
      });
    },
    //题目-提交
    subjectSubmit(type) {
      try {
        if (!this.subjectForm.subjectTitle) {
          throw new Error('请填写题目标题');
        }
        if (!this.subjectForm.subjectType) {
          throw new Error('请选择题目类型');
        }
        if (!this.subjectForm.subjectLabelGuid) {
          throw new Error('请选择题目标签');
        }

        let needOptions =
          this.subjectForm.subjectType == '调研对象' ||
          (
            (this.subjectForm.subjectType == '单选题' || this.subjectForm.subjectType == '多选题') &&
            this.subjectForm.subjectItemType == '1'
          );

        if (needOptions) {
          if (!this.subjectForm.selectItems.length) {
            throw new Error('请添加选项');
          }
          this.subjectForm.selectItems.forEach((item) => {
            if (!item.text) {
              throw new Error('请填写选项名称');
            }
          });
          for (var i = 0; i < this.subjectForm.selectItems.length; i++) {
            for (var j = i + 1; j < this.subjectForm.selectItems.length; j++) {
              if (this.subjectForm.selectItems[i].text == this.subjectForm.selectItems[j].text) {
                throw new Error(this.subjectForm.selectItems[i].text + '，选项名称不能重复');
              }
            }
          }
        }

        if (
          this.subjectForm.subjectType == '单选题' ||
          this.subjectForm.subjectType == '多选题'
        ) {
          if (!this.subjectForm.subjectItemType) {
            throw new Error('请选择题型分类');
          }
          if (this.subjectForm.subjectItemType == '4' && !this.subjectForm.dictGuid) {
            throw new Error('请选择字典名称');
          }
          if (
            (this.subjectForm.subjectItemType == '1' || this.subjectForm.subjectItemType == '4') &&
            !this.subjectForm.interactType
          ) {
            throw new Error('请选择交互方式');
          }
          this.subjectForm.selectItems.forEach((item) => {
            if (item.isAdd && (!item.subjectItem || !item.subjectItem.subjectType)) {
              throw new Error('请设置子答案规则');
            }
          });
        }

        if (this.subjectForm.subjectType == '选择区域' && !this.subjectForm.validateGuid) {
          throw new Error('请选择验证输入方式');
        }

        if (
          this.subjectForm.subjectType == '单行填空题' ||
          this.subjectForm.subjectType == '年月' ||
          this.subjectForm.subjectType == '年月日' ||
          this.subjectForm.subjectType == '填写日期' ||
          this.subjectForm.subjectType == '定位签到'
        ) {
          if (!this.subjectForm.validateGuid) {
            throw new Error('请选择验证输入方式');
          }
        }
        if (
          this.subjectForm.subjectType == '单行填空题' ||
          this.subjectForm.subjectType == '年月' ||
          this.subjectForm.subjectType == '年月日' ||
          this.subjectForm.subjectType == '填写日期' ||
          this.subjectForm.subjectType == '定位签到'
        ) {
          if (!this.subjectForm.isValidateUnique) {
            throw new Error('请选择唯一性校验');
          }
        }
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      /* if(this.subjectForm.subjectType !== '单选题' || this.subjectForm.subjectType !== '多选题' || this.subjectForm.subjectType !== '调研对象'){
        let isTrue = this.subjectForm.selectItems.some(m=>{return m.isCorrect == true})
        let isFalse = this.subjectForm.selectItems.some(m=>{return m.isCorrect == false})
        let isNull = this.subjectForm.selectItems.some(m=>{return m.isCorrect == null})
        let isAllFalse = this.subjectForm.selectItems.every(m=>{return m.isCorrect == false})
        console.log(isTrue)
        if((isTrue && isNull) || (isFalse && isNull)){
          this.$message.error('请完善正确/错误答案设置');
          return
        }
        if(isAllFalse){
          this.$message.error('请设置正确答案');
          return
        }
      } */
      if (this.isEdit) {
        this.updateSubjectReq();
      } else {
        this.addSubjectReq();
      }
    },
    //手动题目-调研对象
    subjectTypeChange(val) {
      let isSwitchBetweenChoice =
        (this.oldSubjectType == '单选题' && val == '多选题') ||
        (this.oldSubjectType == '多选题' && val == '单选题');

      this.subjectForm.subjectItemType = '';
      this.subjectForm.dictGuid = '';
      this.subjectForm.dictName = '';
      this.subjectForm.interactType = '';
      this.subjectForm.validateGuid = '';
      this.subjectForm.hasChild = false;
      this.subjectForm.isSupportAll = false;

      if (val == '调研对象') {
        this.getTargetList();
      } else if (!isSwitchBetweenChoice) {
        this.subjectForm.selectItems = [];
      } else {
        // 单选/多选互切时，清理每个选项的子答案状态
        this.subjectForm.selectItems.forEach((item) => {
          item.isAdd = false;
          item.isAddWrite = false;
          item.subjectItem = null;
        });
      }

      this.oldSubjectType = val;
      this.getValidateList(val);
    },
    //手动题目-获取调研对象
    getTargetList() {
      let self = this;
      let query =  {
        pageIndex: 1,
        pageSize: -1,
        bizType: '调研对象',
        // tenantGuid:localStorage.guid
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data.records || null;
          if(data){
            let arr = [];
            let newArr = [];
            data.forEach((i,index)=>{
              let obj = {
                label: i.paramName,
                value: i.paramName,
              };
              arr.push(obj)
              let objData = {
                text: i.paramName,
                orderNum: index,
                value: i.paramName,
                isCorrect: null,
                isAdd: false,
                isAddWrite: false,
                subjectItem: null,
              };
              newArr.push(objData)
            })
            this.targetOption = arr;
            this.subjectForm.selectItems = newArr;
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 导入标签
    importLabel() {
      this.$router.push({
        path: '/labelImportRecord',
      })
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      this.exportSettingLoading = true;
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          self.exportSettingLoading = false;
          let blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    // 导出标签
    async exportLabel() {
      this.fullscreenLoading = true;
      const { data } = await this.api.get(
        `/${serverConfig.msSalesPerformService}/subject-stock/label/export`,
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.reportJx(data.data.colNames, data.data.datas, data.data.sheetName, data.data.fileNam);
    },
    /** 示例图片 上传相关 */
    handleBillRemove(file) {
      let self = this;
      self.subjectForm.pictUrl.forEach(function (j, ind) {
        if (j.path == file.path) {
          self.subjectForm.pictUrl.splice(ind, 1);
        }
      });
    },
    uploadBillImage(file) {
      let self = this;
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            var path = decodeURIComponent(res.data.data);
            var str = file.file.name;
            let lastDotIndex = str.lastIndexOf('.');
            if (lastDotIndex !== -1) {
              str = str.substring(0, lastDotIndex);
            }
            let item = {
              fileName: str,
              path: res.data.data,
            };
            self.subjectForm.pictUrl.push(item);
            self.$forceUpdate();
            self.$message.success('上传成功');
          } else {
            self.subjectForm.pictUrl = JSON.parse(JSON.stringify(self.subjectForm.pictUrl));
            self.$forceUpdate();
            self.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          self.$message.error(err);
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 5 个文件`);
    },
    handlePictureCardPreview(file) {
      let srcLists = this.subjectForm.pictUrl.map(e => e.path);
      let index = srcLists.indexOf(file.path);
      if (index !== -1) {
        srcLists = [file.path, ...srcLists.slice(index + 1), ...srcLists.slice(0, index)];
      }
      window.open(file.path, '_blank');
    },
  },
};
</script>
<style scoped>
.import-btn-tips {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: baseline;
}
.file-list-box{
  text-align: left;
}
.picture-box{
  display: flex;
  flex-direction: column;
  margin-left: 128px;
  .flex{
    display: flex;
  }
}
.search-area-div {
  flex-shrink: 0;
  text-align: right;
  margin-right: 4px;
}
.icon-management {
  overflow-y: scroll;
  overflow-x: hidden;
}
.icon-management .top {
  background: #fff;
  text-align: left;
  padding: 10px;
}
.menu-contain {
  margin-top: 1px;
  display: flex;
  margin-left: 0;
}
.menu {
  width: 300px;
  background: #fff;
  min-height: 600px;
  position: fixed;
  height: calc(100vh - 90px);
  border-right: 1px solid #e8e8e8;
}
.contain {
  width: calc(100% - 300px);
  margin-left: 300px;
  margin-right: 0;
  .search-area {
    margin-bottom: 1px;
  }
  .content-main-box {
    height: 100%;
  }
}
.menu-item {
  display: flex;
  justify-content: space-between;
  padding: 0 4px;
  align-items: center;
  cursor: pointer;
}
.label-tree {
  padding: 0 4px;
  border-bottom: 1px solid #E5E5E5;
  overflow: auto;
  height: calc(100vh - 250px);

}
.label-tree .el-tree-node {
  padding: 4px 0;
}
.label-tree .el-tree-node__content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tree-node-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.node-name {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tree-operate {
  opacity: 0;
  transition: opacity 0.2s;
  margin-left: auto;
}
.el-tree-node__content:hover .tree-operate {
  opacity: 1;
}
.menu-item .name {
  width: 250px;
  height: 36px;
  line-height: 36px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.operate span {
  font-size: 18px;
}
.title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  background: #fff;
  position: relative;
}
.title span {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}
.pic-list {
  height: auto;
  background: #fff;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
}
.img-desc {
  width: 168px;
  height: 190px;
}
.pic-list .img {
  margin-left: 20px;
  width: 150px;
  height: 150px;
  background: rgba(0, 0, 0, 0.06);
}
.desc {
  text-align: center;
  margin-bottom: 20px;
  width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ .bread {
  position: fixed;
}
.upload {
  width: 150px;
  height: 150px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  display: none;
}
.img-desc {
  position: relative;
}
.del-icon {
  position: absolute;
  right: -2px;
  top: 0;
  width: 20px;
  height: 20px;
}
.menu-item .del,
.menu-item .edit {
  display: none;
}
.menu-item:hover .del {
  display: inline;
}
.menu-item:hover .edit {
  display: inline;
}
.left-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.left-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.left-add-icon {
  font-size: 20px;
  color: #4fa1a4;
  cursor: pointer;
}
.menu /deep/ .el-button {
  width: 100%;
}
.menu /deep/ .el-button:focus,
.menu /deep/ .el-button:hover {
  border-color: #4fa1a4;
  color: #4fa1a4;
}
.search-input {
  margin-bottom: 20px;
}
.import-export-btn {
  position: absolute;
  bottom: 15px;
  left: 10px;
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 34px;
}
.btn-item {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  gap: 8px;
  /* cursor: pointer; */
  /* color: #666; */
  /* transition: color 0.2s; */
}
.btn-item:hover {
  color: #4fa1a4;
}
.btn-item i {
  font-size: 18px;
  /* margin-bottom: 4px; */
}
.btn-divider {
  width: 1px;
  height: 30px;
  background: #ddd;
  margin: 0 10px;
}
.label {
  font-size: 16px;
  background: #fff;
  text-align: left;
  padding-bottom: 20px;
}
.subject-table {
  background: #fff;
  padding: 20px;
  margin-top: 10px;
}

.clear-btn {
  height: 32px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  padding: 10px 20px;
  box-sizing: border-box;
  color: #333;
  background: #fff;
  cursor: pointer;
  border: 1px solid #dcdee0;
  margin-bottom: 20px;
}
.add-btn {
  height: 32px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  padding: 10px 20px;
  box-sizing: border-box;
  color: #fff;
  background: #649fa4;
  cursor: pointer;
}
.subject-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.subject-title-name {
  font-size: 16px;
  font-weight: bold;
  text-align: left;
}
.subject-title-name span {
  width: 6px;
  height: 14px;
  display: inline-block;
  background: #4fa1a4;
  margin-right: 10px;
}
.subject-select {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: #454545;
}
.subject-select div {
  width: 50%;
  text-align: center;
  border: 1px solid #dddddd;
  cursor: pointer;
}
.subject-select div:first-child {
  border-right: 1px solid #ddd;
}
.subject-select .true-active {
  color: #649fa4;
  background: rgba(234, 246, 247, 0.39);
  border: 1px solid #b0d0d3 !important;
}
.subject-select .false-active {
  color: #ff4d4d;
  background: rgba(255, 232, 232, 0.39);
  border: 1px solid #ff9b9b;
}
.subject-add-btn {
  font-size: 14px;
  color: #649fa4;
  cursor: pointer;
  padding: 5px 9px;
  background: #f2f8f8;
  border: 1px solid #bfd2d3;
}
.subject-add-btn span {
  width: 18px;
  height: 18px;
  line-height: 18px;
  display: inline-block;
  margin-right: 6px;
  border: 1px solid #649fa4;
}
.opreateIcon {
  display: inline-block;
  width: 80px;
  text-align: left;
}

.opreateIcon i {
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  padding: 2px 6px;
  margin-left: 4px;
  background: #F5F7FA;
}

.opreateIcon i:hover {
  color: #4fa1a4;
}
</style>
